import {
  api,
  type,
  urls
} from "./api";
const URLSearchParams = require('@ungap/url-search-params');
import "babel-polyfill";
import picturefill from "picturefill";

const pictureSupport = !!window.HTMLPictureElement;

const fixPictures = () => {
  if (pictureSupport === false) {
    picturefill();
  }
};

const getEnv = () => {
  if(window.location.href.indexOf('localhost') > -1) {
    return 'localhost';
  } else if(window.location.href.indexOf('stage.mrm.com.ar') > -1) {
    return 'stage';
  } else {
    return 'production';
  }
};

const elementCreater = (type, text = "", attributes = {}) => {
  let node = document.createElement(type);

  if (text !== "") {
    text = document.createTextNode(text);
    node.appendChild(text);
  }

  Object.keys(attributes).map(attribute => {
    node.setAttribute(attribute, attributes[attribute]);
  });

  return node;
};

const formatMoney = (
  amount,
  decimalCount = 2,
  decimal = ",",
  thousands = "."
) => {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
    ).toString();
    let j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount ?
        decimal +
        Math.abs(amount - i)
        .toFixed(decimalCount)
        .slice(2) :
        "")
    );
  } catch (e) {
    console.log(e);
  }
};

const replacer = (text, params) => {
  Object.keys(params).map(param => {
    text = text.replace(new RegExp("\\$" + param, "g"), params[param]);
  });

  return text;
};

const orderSort = (data, inSelf = true, self = [], each = []) => {
  if (Array.isArray(data)) {
    if (inSelf) {
      data = data.sort(sort);
    }

    if (each.length > 0) {
      data.map((element, index) => {
        each.map(item => {
          element[item].sort(sort);
        });
      });
    }
  } else {
    self.map(element => {
      data[element].sort(sort);
    });
  }

  return data;
};

var removeClass = function (selector, className) {
  var elem = document.querySelectorAll(selector);
  for (var i = 0, len = elem.length; i < len; i++) {
    elem[i].classList.remove(className);
  }
};

/**
 * Add class
 *
 * @param {String} selector With element format like #id or .class
 * @param {String} className
 */
var addClass = function (selector, className) {
  var elem = document.querySelectorAll(selector);
  for (var i = 0, len = elem.length; i < len; i++) {
    elem[i].classList.add(className);
  }
};

var removeAttribute = function (selector, attr) {
  var elem = document.querySelectorAll(selector);
  for (var i = 0, len = elem.length; i < len; i++) {
    elem[i].removeAttribute(attr);
  }
};

var addAttribute = function (selector, attr, value) {
  var elem = document.querySelectorAll(selector);
  for (var i = 0, len = elem.length; i < len; i++) {
    elem[i].setAttribute(attr, value);
  }
};

const sort = (a, b) => a.order - b.order;

const addOptions = (items, dest, defaultOption = "", valueLabel = "value") => {
  if (defaultOption !== "") {
    let node = elementCreater("option", defaultOption, {
      value: "",
      selected: true,
      disabled: true
    });
    dest.appendChild(node);
  }

  items.map(item => {
    let node = elementCreater("option", item.name, {
      value: item[valueLabel] != null ? item[valueLabel] : item.name
    });
    dest.appendChild(node);
  });
};

const allowOnlyNumbers = e => {
  let keyCodes = [46, 8, 9, 27, 13, 110, 190];

  if (
    keyCodes.includes(e.keyCode) ||
    // Allow: Ctrl/cmd+A
    (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
    // Allow: Ctrl/cmd+C
    (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
    // Allow: Ctrl/cmd+X
    (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
    // Allow: home, end, left, right
    (e.keyCode >= 35 && e.keyCode <= 39)
  ) {
    // let it happen, don't do anything
    return;
  }
  // Ensure that it is a number and stop the keypress
  if (
    (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
    (e.keyCode < 96 || e.keyCode > 105)
  ) {
    e.preventDefault();
  }
};

/**
 *
 *
 * @param {HTMLElement} node
 */
const clearElements = node => {
  while (node.firstChild) {
    node.removeChild(node.firstChild);
  }
};

const removeNoNumbers = string => {
  return string.replace(/[^0-9]+/gm, "");
};

const nodeParent = (
  node,
  params = {
    attribute: "class",
    value: ""
  }
) => {
  while (node.parentNode != null) {
    if (
      node != null &&
      node.getAttribute != null &&
      node.getAttribute(params.attribute) != null &&
      node.getAttribute(params.attribute).includes(params.value)
    ) {
      return node;
    }

    node = node.parentNode;
  }

  return null;
};

const show = (value = "", type = "id") => {
  showHide(value, type, "remove");
};

const hide = (value = "", type = "id") => {
  showHide(value, type, "add");
};

const showHide = (value = "", type = "id", action = "remove") => {
  let nodes;

  switch (type) {
    case "id":
      if (typeof value === "string") {
        let node = document.getElementById(value);

        if (node != null) {
          node.classList[action]("hide");
        }
      } else if (typeof value === "object") {
        value.map(id => {
          let node = document.getElementById(id);

          if (node != null) {
            node.classList[action]("hide");
          }
        });
      }
      break;
    case "name":
      nodes = document.getElementsByName(value);
      break;
    case "class":
      nodes = document.getElementsByClassName(value);
      break;
    case "tag":
      nodes = document.getElementsByTagName(value);
      break;
  }

  if (nodes != null) {
    for (let i = 0; i < nodes.length; i++) {
      nodes[i].classList[action]("hide");
    }
  }
};

function checkDateInput() {
  var input = document.createElement("input");
  input.setAttribute("type", "date");

  var notADateValue = "not-a-date";
  input.setAttribute("value", notADateValue);

  return input.value !== notADateValue;
}

function hasClass(element, className) {
  return (" " + element.className + " ").indexOf(" " + className + " ") > -1;
}

// first add raf shim
// http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
window.requestAnimFrame = (function () {
  return (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60);
    }
  );
})();

// main function
function scrollToY(scrollTargetY = 0, speed = 2000, easing = "easeOutSine") {
  // scrollTargetY: the target scrollY property of the window
  // speed: time in pixels per second
  // easing: easing equation to use

  let scrollY = window.scrollY,
    currentTime = 0;

  // min time .1, max time .8 seconds
  var time = Math.max(
    0.1,
    Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8)
  );

  // easing equations from https://github.com/danro/easing-js/blob/master/easing.js
  let easingEquations = {
    easeOutSine: function (pos) {
      return Math.sin(pos * (Math.PI / 2));
    },
    easeInOutSine: function (pos) {
      return -0.5 * (Math.cos(Math.PI * pos) - 1);
    },
    easeInOutQuint: function (pos) {
      if ((pos /= 0.5) < 1) {
        return 0.5 * Math.pow(pos, 5);
      }
      return 0.5 * (Math.pow(pos - 2, 5) + 2);
    }
  };

  // add animation loop
  function tick() {
    currentTime += 1 / 60;

    var p = currentTime / time;
    var t = easingEquations[easing](p);

    if (p < 1) {
      requestAnimFrame(tick);

      window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
    } else {
      window.scrollTo(0, scrollTargetY);
    }
  }

  // call it once to get started
  tick();
}


/**
 *
 *
 * @param {String} nr This string will be padded
 * @param {Number} n New min length
 * @param {String} [str='0'] With what will be filled
 * @returns
 */
function padLeft(nr, n, str) {
  return Array(n - String(nr).length + 1).join(str || '0') + nr;
}

function roundToTwo(num) {
  if (typeof num === "string") {
    num = parseFloat(num);
  }

  return parseFloat(num.toFixed(2));
}

/**
 * @description Replace not numbers only after change
 *
 * @param {Event} e 
 */
const changeIfNumbers = (e) => {
  let input = e.target;
  let value = input.value;
  let replaced = removeNoNumbers(value);

  if (replaced != value || replaced === "") {
    input.value = replaced;
  }

};

const isProdOrPP = () => {
  return type === 'prod' || type === 'pp';
};

const isStage = () => {
  return type === 'stage';
};

const fixPDFServiceUrl = (url) => {
  if (isProdOrPP() || isStage() || type === 'localtostage') {
    url = isProdOrPP() ? url.replace('Services/', '') : urls.stage + url;
  }
  return url;
};

const fixImageServiceUrl = (data, type) => {
  if (isProdOrPP() || isStage() || type === 'localtostage') {
    const replacer = isProdOrPP() ? url => url.replace('Services/', '') : url => urls.stage + url;

    if (type === 'home') {
      for (let i = 0; i < data.length; i++) {
        data[i].image.mobile = replacer(data[i].image.mobile);
        data[i].image.bigBrowser = replacer(data[i].image.bigBrowser);
      }
    } else if (type === 'model') {
      data.mainImage.mobile = replacer(data.mainImage.mobile);
      data.mainImage.bigBrowser = replacer(data.mainImage.bigBrowser);

      for (let i = 0; i < data.images.length; i++) {
        data.images[i].mobile = replacer(data.images[i].mobile);
        data.images[i].bigBrowser = replacer(data.images[i].bigBrowser);
      }

    } else if (type === 'models') {

      for (let i = 0; i < data.length; i++) {
        data[i].imageMobile = replacer(data[i].imageMobile);
        data[i].imageBigBrowser = replacer(data[i].imageBigBrowser);
      }
    } else {
      console.log('Fix service undefined, please conctact a developer');
    }
  }

  return Promise.resolve(data);
};

const createGUID = () => {
  const random = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };
  return random() + random() + '-' + random() + '-' + random() + '-' +
    random() + '-' + random() + random() + random();
};

const pxss = (value) => {
  var lt = /</g,
    gt = />/g,
    ap = /'/g,
    ic = /"/g;
  return value.toString().replace(lt, "&lt;").replace(gt, "&gt;").replace(ap, "&#39;").replace(ic, "&#34;");
};

const getURLParams = () => {
  var searchParams = new URLSearchParams(window.location.search);

  var params = {};
  for (var pair of searchParams.entries()) {
    params[pair[0]] = pair[1];
  }

  return params;
} 


export default {
  getURLParams,
  pxss,
  removeNoNumbers,
  allowOnlyNumbers,
  elementCreater,
  formatMoney,
  replacer,
  orderSort,
  removeClass,
  addClass,
  addOptions,
  removeAttribute,
  addAttribute,
  clearElements,
  nodeParent,
  show,
  hide,
  checkDateInput,
  hasClass,
  scrollToY,
  padLeft,
  roundToTwo,
  fixPictures,
  changeIfNumbers,
  fixImageServiceUrl,
  fixPDFServiceUrl,
  createGUID,
  ENVIRONMENT: getEnv()
};